export default __webpack_public_path__ + "static/media/cms-search.745e7280.svg";